<template>
  <img
    :class="{ photo: true, zoom: zoom }"
    :alt="'Photo de ' + pseudo"
    :src="src"
    @contextmenu="context"
    draggable="false"
    unSelectable
  />
</template>

<script>
export default {
  name: "Photo",
  props: {
    pic: Object,
    profile: Object,
    cadre: {
      type: String,
      default: "cadrePhoto"
    },
    zoom: {
      type: Boolean,
      default: false
    },
    thumb: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    context: function(event) {
      event.preventDefault();
    }
  },

  computed: {
    src: function() {
      if (this.thumb) return this.pic.thumbName;
      else return this.pic.name;
    },

    pseudo() {
      if (this.profile) return this.profile.pseudo;
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

img.zoom {
  cursor: url("/assets/icons/loupe.png"), pointer;
}

img {
  user-select: none;
}
</style>
